export class RefProtectionGrele {
    id: number;
    code: string;
    libelle: string;
}
